import innerHTML from 'utils/DOM/innerHTML'

function showPhoneDash(phone) {
  if (phone.promo_number_formatted_dash) {
    innerHTML('.promo_number_formatted_dash', phone.promo_number_formatted_dash)
  }
}

export { showPhoneDash }
